import React, { useContext, useEffect, useRef, useState } from "react";
import closebutton from "../../assests/closebutton.svg";
import styles from "./GiftClaimPopup.module.css";
import _, { isEmpty } from "lodash";
import axios from "axios";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";
import { mediaStorage } from "../../store/firebase-config";
import { ref, uploadBytesResumable } from "firebase/storage";
import UploadPopup from "../UploadPopup/UploadPopup";

export default function GiftClaimPopup({
  data,
  claimOptions,
  setPopup,
  setSingleFileDetails,
  contestMetaData,
}) {
  const initialValues = { claimEmail: data?.email || "" };
  const [formDetails, setFormDetails] = useState(initialValues);
  const [errorMessage, setErrorMessage] = useState({});
  const [selectedType, setSelectedType] = useState({});

  const { userIdToken } = useContext(Context);
  const { currentUser, newUserId, userId, loginChecker } = useUserAuth();
  const [loading, setLoading] = useState(false);
  const [source, setSource] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const inputRef = useRef();
  const [sourceDp, setSourceDp] = useState();
  const [selectedFileDp, setSelectedFileDp] = useState();
  const inputRefDp = useRef();
  const [upload, setUpload] = useState(false);
  const [feature, setFeature] = useState(false);
  const token = userIdToken || currentUser?.accessToken;

  useEffect(() => {
    if (isEmpty(userId) && isEmpty(newUserId)) {
      loginChecker(token);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const buttonType = e.nativeEvent.submitter.getAttribute("type");
    if (buttonType === "submit") {
      let errors = {};

      if (_.isEmpty(formDetails?.prizeType)) {
        errors.prizeType = "Please select an option";
      }
      if (_.isEmpty(formDetails?.address)) {
        errors.address = "Please fill above details";
      }
      if (_.isEmpty(formDetails?.claimEmail)) {
        errors.email = "Please enter your email to get updates";
      }
      if (contestMetaData?.proofRequired && _.isEmpty(source)) {
        errors.proofData = "Please upload proof of your entry";
      }
      if (feature) {
        if (_.isEmpty(sourceDp)) {
          errors.participantPhoto = "Please upload participant photo";
        }
        if (_.isEmpty(formDetails?.bio)) {
          errors.bio = "Please fill above details";
        }
        if (_.isEmpty(formDetails?.achievement)) {
          errors.achievement = "Please fill above details";
        }
        if (_.isEmpty(formDetails?.occupation)) {
          errors.occupation = "Please fill above details";
        }
      }

      setErrorMessage(errors);
      if (_.isEmpty(errors)) {
        setUpload(true);
        let fileData = {};
        const participantPhoto = await fileUploadDp();
        fileData.participantPhoto = participantPhoto;
        if (contestMetaData?.proofRequired) {
          const data = await fileUpload();
          fileData.proofData = data;
          await updateEntry(fileData);
        } else {
          await updateEntry(fileData);
        }
        setUpload(false);
      }
    }
  };
  const updateEntry = async (fileData) => {
    setLoading(true);
    try {
      let config = {
        method: "PATCH",
        url: `${process.env.REACT_APP_EDIT_ENTRY_PRIZECLAIM}/${data?.orgId}/${data?.campaignId}/${data?.contestId}/${data?._id}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          prizeClaimDetails: {
            ...formDetails,
            ...fileData,
            giftWorth:
              data?.winnerObject?.prizeWorth || contestMetaData?.giftWorth,
          },
          giftClaimStatus: "ADDRESS_UPDATED",
        },
      };
      const apiResponse = await axios(config);
      if (apiResponse?.data?.status == "success") {
        setSingleFileDetails((prevState) => ({
          ...prevState,
          giftClaimStatus: "ADDRESS_UPDATED",
        }));
        setPopup(false);
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };
  const fileUpload = async () => {
    try {
      let userIdFromLocalOrApi = newUserId || userId;
      let randomId = Math.floor(Date.now() * Math.random());
      let filePath = `${data?.orgId}/${data?.campaignId}/${data?.contestId}/${userIdFromLocalOrApi}/entry_proof_${randomId}`;
      const storageRef = ref(mediaStorage, filePath);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);
      await uploadTask;

      // const url = await getDownloadURL(uploadTask.snapshot.ref);
      const proofData = {
        fileSize: selectedFile.size,
        fileType: selectedFile.type,
        fileUrl: "https://storage.googleapis.com/goviralmedias/" + filePath,
      };
      setFormDetails((prevState) => ({
        ...prevState,
        proofData: proofData,
      }));
      return proofData;
    } catch (error) {
      console.error(error);
    }
  };
  const fileUploadDp = async () => {
    try {
      let userIdFromLocalOrApi = newUserId || userId;
      let randomId = Math.floor(Date.now() * Math.random());
      let filePath = `${data?.orgId}/${data?.campaignId}/${data?.contestId}/${userIdFromLocalOrApi}/participant_photo_${randomId}`;
      const storageRef = ref(mediaStorage, filePath);
      const uploadTask = uploadBytesResumable(storageRef, selectedFileDp);
      await uploadTask;

      // const url = await getDownloadURL(uploadTask.snapshot.ref);
      const participantPhoto = {
        fileSize: selectedFileDp.size,
        fileType: selectedFileDp.type,
        fileUrl: "https://storage.googleapis.com/goviralmedias/" + filePath,
      };
      setFormDetails((prevState) => ({
        ...prevState,
        participantPhoto: participantPhoto,
      }));
      return participantPhoto;
    } catch (error) {
      console.error(error);
    }
  };
  const handleFileChange = async (event) => {
    const selectedFile = new FormData();
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    selectedFile.append("selectedFile", file);
    setSource(url);
    setSelectedFile(file);
  };
  const handleChoose = async () => {
    inputRef.current.click();
  };

  const handleFileChangeDp = async (event) => {
    const selectedFileDp = new FormData();
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    selectedFileDp.append("selectedFileDp", file);
    setSourceDp(url);
    setSelectedFileDp(file);
  };
  const handleChooseDp = async () => {
    inputRefDp.current.click();
  };
  const handleInputChange = (e) => {
    setFormDetails((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  return (
    <>
      {upload && <UploadPopup />}
      <div
        className={`fixed top-0 left-0 h-[100%] w-[100%] z-10 px-[20px] pb-[100px] ${styles.popupBackground} overflow-y-auto no-scrollbar`}
      >
        <div className={`${styles.popupParent}`}>
          <div className="relative w-[100%]">
            <div className="flex justify-between items-center w-[100%] pt-[20px] px-[20px]">
              <p className="text-regular-bold text-[#CDCDCD]">
                Claim Your Gift
              </p>
              <img
                src={closebutton}
                onClick={() => setPopup(false)}
                className=" hover:cursor-pointer"
              />
            </div>

            <p className="text-regular px-[20px] pt-[20px] text-[#B5B5B5]">
              {data?.winnerObject?.prizeWorth || contestMetaData?.giftWorth}
            </p>
            <form className={styles.claimForm} onSubmit={handleSubmit}>
              <div className="flex flex-col gap-[10px] mt-[20px]">
                <label className="text-regular ">
                  Gift Options <span className="text-[#FA6B6B]">*</span>
                </label>
                <select
                  onChange={(e) => {
                    setFormDetails((prevState) => ({
                      ...prevState,
                      prizeType: JSON.parse(e.target.value)?.prizeType,
                    }));
                    setSelectedType(JSON.parse(e.target.value));
                  }}
                  className=""
                >
                  <option selected disabled>
                    Select an Option
                  </option>
                  {claimOptions?.map((el) => {
                    return (
                      <>
                        <option className="" value={JSON.stringify(el)}>
                          {el?.prizeDesc}
                        </option>
                      </>
                    );
                  })}
                </select>
                {errorMessage?.prizeType && (
                  <p className="text-[#FA6B6B] text-smallest ">
                    {errorMessage?.prizeType}
                  </p>
                )}
              </div>

              {!isEmpty(selectedType?.prizeAddress) && (
                <>
                  {selectedType?.image && (
                    <div className=" bg-[#1c1c1c] mt-[30px] w-[100%] h-[160px] flex items-center justify-center overflow-hidden">
                      <img
                        src={selectedType?.image}
                        className="h-full w-full object-contain"
                      />
                    </div>
                  )}

                  <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                    <label htmlFor="address">
                      {selectedType?.prizeAddress}{" "}
                      <span className="text-[#FA6B6B]">*</span>
                    </label>
                    {selectedType?.inputType == "textArea" ? (
                      <textarea
                        type="text"
                        id="address"
                        name="address"
                        value={formDetails.address}
                        placeholder={selectedType?.prizeInfo}
                        onChange={handleInputChange}
                        className={errorMessage?.address ? styles.error : ""}
                      />
                    ) : (
                      <input
                        type="text"
                        id="address"
                        name="address"
                        value={formDetails.address}
                        placeholder={selectedType?.prizeInfo}
                        onChange={handleInputChange}
                        className={errorMessage?.address ? styles.error : ""}
                      />
                    )}
                    {errorMessage?.address && (
                      <p className="text-[#FA6B6B] text-smallest ">
                        {errorMessage?.address}
                      </p>
                    )}
                  </div>

                  <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                    <label htmlFor="email">
                      Contact Email
                      <span className="text-[#FA6B6B]">*</span>
                    </label>
                    <input
                      type="text"
                      id="claimEmail"
                      name="claimEmail"
                      value={formDetails?.claimEmail}
                      placeholder="Enter your email to get updates of your entry"
                      onChange={handleInputChange}
                      className={errorMessage?.email ? styles.error : ""}
                    />

                    {errorMessage?.email ? (
                      <p className="text-[#FA6B6B] text-smallest ">
                        {errorMessage?.email}
                      </p>
                    ) : (
                      <p className="text-[#B5B5B5] text-smallest ">
                        Enter your email to get updates
                      </p>
                    )}
                  </div>
                  {contestMetaData?.proofRequired && (
                    <div className="flex flex-col  mt-[20px]">
                      <label htmlFor="participantName" className=" ">
                        Proof of Entry <span className="text-[#FA6B6B]">*</span>
                      </label>
                      <div className="w-[100%]">
                        <span className="text-[#B5B5B5]  text-smallest">
                          {contestMetaData?.proofText}
                        </span>
                      </div>
                      <input
                        ref={inputRef}
                        className="hidden"
                        type="file"
                        onChange={handleFileChange}
                        accept={
                          contestMetaData?.proofFileType || "image/*,video/*"
                        }
                      />
                      <div className="flex w-full justify-center mt-[10px]">
                        {source ? (
                          <div
                            className="w-[100%] min-h-[60px] mb-[10px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                            onClick={handleChoose}
                          >
                            <div>
                              <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                                <img src={source} className="w-auto h-[100%]" />
                              </div>
                              <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                                Replace
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div
                            className=" bg-[#1c1c1c] mb-[5px] w-[100%] min-h-[160px] flex items-center justify-center overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                            onClick={handleChoose}
                          >
                            <div>
                              <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                                Upload
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                      {errorMessage?.proofData && (
                        <p className="text-[#FA6B6B] text-smallest mt-[5px]">
                          {errorMessage?.proofData}
                        </p>
                      )}
                    </div>
                  )}

                  <div className="seperator" />
                  <div className=" mt-[25px] mb-[24px]">
                    <label htmlFor="participantName" className=" ">
                      Feature in Goviral
                    </label>
                    <div className="w-[100%]">
                      <span className="text-[#B5B5B5]  text-smallest">
                        Goviral is excited to introduce both online and offline
                        magazines dedicated to highlighting our participants and
                        providing a platform for their achievements. Would you
                        like to be a part of this journey?
                      </span>
                    </div>
                  </div>
                  <div className=" mt-[25px] mb-[24px]">
                    <div className="flex  items-center justify-start   gap-[10px]">
                      <input
                        type="checkbox"
                        id="tc"
                        name="tc"
                        value={formDetails.tc}
                        onClick={() => {
                          setFeature((prev) => !prev);
                          setFormDetails((prevState) => ({
                            ...prevState,
                            feature: !prevState?.feature,
                          }));
                        }}
                        checked={feature}
                        className="w-[30px] h-[30px] rounded-[5px] focus:outline-none "
                      />
                      <label htmlFor="tc">
                        Agree to feature this entry in goviral
                      </label>
                    </div>
                  </div>
                  {feature && (
                    <>
                      <div className="flex flex-col  mt-[20px]">
                        <label htmlFor="participantName" className=" ">
                          Participant Photo
                          <span className="text-[#FA6B6B]">*</span>
                        </label>

                        <input
                          ref={inputRefDp}
                          className="hidden"
                          type="file"
                          onChange={handleFileChangeDp}
                          accept="image/*"
                        />
                        <div className="flex w-full justify-center mt-[10px]">
                          {sourceDp ? (
                            <div
                              className="w-[100%] min-h-[60px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                              onClick={handleChooseDp}
                            >
                              <div>
                                <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                                  <img
                                    src={sourceDp}
                                    className="w-auto h-[100%]"
                                  />
                                </div>
                                <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                                  Replace
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div
                              className="bg-[#1c1c1c] mb-[5px] w-[100%] min-h-[160px] flex items-center justify-center overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                              onClick={handleChooseDp}
                            >
                              <div>
                                <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                                  Upload
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                        {errorMessage?.participantPhoto && (
                          <p className="text-[#FA6B6B] text-smallest mt-[5px]">
                            {errorMessage?.participantPhoto}
                          </p>
                        )}
                      </div>

                      <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                        <label htmlFor="bio">
                          Participant Bio{" "}
                          <span className="text-[#FA6B6B]">*</span>
                        </label>
                        <textarea
                          type="text"
                          id="bio"
                          name="bio"
                          value={formDetails.bio}
                          placeholder="Please provide your bio with the following details: Full name, interests and hobbies "
                          onChange={handleInputChange}
                          className={errorMessage?.bio ? styles.error : ""}
                        />
                        {errorMessage?.bio && (
                          <p className="text-[#FA6B6B] text-smallest ">
                            {errorMessage?.bio}
                          </p>
                        )}
                      </div>
                      <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                        <label htmlFor="achievement">
                          Participant Achievements{" "}
                          <span className="text-[#FA6B6B]">*</span>
                        </label>
                        <textarea
                          type="text"
                          id="achievement"
                          name="achievement"
                          value={formDetails.achievement}
                          placeholder="Please share your achievements and a brief description? "
                          onChange={handleInputChange}
                          className={
                            errorMessage?.achievement ? styles.error : ""
                          }
                        />
                        {errorMessage?.achievement && (
                          <p className="text-[#FA6B6B] text-smallest ">
                            {errorMessage?.achievement}
                          </p>
                        )}
                      </div>
                      <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                        <label htmlFor="occupation">
                          Academics / Profession{" "}
                          <span className="text-[#FA6B6B]">*</span>
                        </label>
                        <input
                          type="text"
                          id="occupation"
                          name="occupation"
                          placeholder="class / occupation"
                          value={formDetails.occupation}
                          onChange={handleInputChange}
                          className={
                            errorMessage?.occupation ? styles.error : ""
                          }
                        />
                        {errorMessage?.occupation && (
                          <p className="text-[#FA6B6B] text-smallest ">
                            {errorMessage?.occupation}
                          </p>
                        )}
                      </div>
                    </>
                  )}
                </>
              )}

              <div className="seperator" />

              <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                <label htmlFor="feedback">Feedback</label>
                <textarea
                  type="text"
                  id="feedback"
                  name="feedback"
                  value={formDetails.feedback}
                  placeholder="We'd love to hear from you! Leave your feedback here to help us enhance your experience. "
                  onChange={handleInputChange}
                />
              </div>
              <div className="w-full mt-[16px] flex">
                <button
                  type="submit"
                  className="ml-auto w-fit drop-shadow px-[12px] py-[5px] bg-[#262626] text-[#f6f6f6] rounded-[10px] text-regular"
                  disabled={loading}
                >
                  {loading ? "Loading" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
